import AttendeeAction from '../attendeeAction';
import { Attendee } from '../../../../models';

export default class PendingAction extends AttendeeAction {
    static NAME = 'pending';
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    static condition(attendee) {
        return attendee.moderation_status !== 'pending';
    }

    static is_available({ event }) {
        return event.is_moderation_enabled;
    }

    run() {
        return Attendee.perform_action(
            'bulk_update_moderation_status',
            this.filtered_items,
            {
                organization: this.organization,
                event: this.event,
                moderationStatus: PendingAction.NAME,
                notifyAttendees: false
            },
            this.isAsync(this.filtered_items)
        );
    }

    get needs_selection() {
        return false;
    }

    get needs_confirm() {
        return false;
    }

    get is_direct() {
        return true;
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
